.zy-capability-map {
  --map-candidate: var(--zy-report-candidate);
  --map-job: var(--zy-report-role);
  --map-gap: var(--zy-report-follow-up);
  --map-strength: var(--zy-report-strength);
  --map-surface: var(--zy-surface, var(--zy-surface));
  color: var(--zy-ink-strong, var(--zy-text-strong));
  width: 100%;
  max-width: 44rem;
  margin: 0 auto;
}
[data-theme="dark"] .zy-capability-map {
  --map-candidate: var(--zy-report-candidate);
  --map-job: var(--zy-report-role);
  --map-gap: var(--zy-report-follow-up);
  --map-strength: var(--zy-report-strength);
  --map-surface: var(--zy-surface);
  color: var(--zy-text-strong);
}
.zy-capability-map svg {
  width: 100%;
  display: block;
  height: auto;
  overflow: visible;
}
.zy-capability-map svg :is(polygon, line, path, circle) {
  vector-effect: non-scaling-stroke;
}
.zy-capability-map__grid {
  fill: none;
  stroke: currentColor;
  opacity: 0.18;
}
.zy-capability-map__axis {
  stroke: currentColor;
  opacity: 0.2;
  stroke-dasharray: 3 5;
}
.zy-capability-map__label {
  fill: currentColor;
  font: 600 14px sans-serif;
}
.zy-capability-map__scale {
  fill: currentColor;
  font: 12px sans-serif;
  opacity: 0.7;
}
.zy-capability-map__candidate {
  stroke: var(--map-candidate);
  stroke-width: 2.5;
  stroke-linejoin: round;
}
.zy-capability-map__job {
  fill: none;
  stroke: var(--map-job);
  stroke-width: 2.5;
  stroke-dasharray: 7 5;
  stroke-linejoin: round;
}
.zy-capability-map__candidate-point {
  fill: var(--map-candidate);
  stroke: var(--map-surface);
  stroke-width: 2;
}
.zy-capability-map__job-point {
  fill: none;
  stroke: var(--map-job);
  stroke-width: 2.5;
}
.zy-capability-map__gap {
  stroke: var(--map-gap);
  stroke-width: 5;
}
.zy-capability-map__strength {
  stroke: var(--map-strength);
  stroke-width: 6;
  stroke-dasharray: 2 3;
}
.zy-capability-map__legend {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.6rem 1rem;
  font-size: 0.8rem;
}
.zy-capability-map__legend span {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
}
.zy-capability-map__legend i {
  width: 1.2rem;
  border-top: 3px solid var(--map-candidate);
}
.zy-capability-map__legend .zy-capability-map__key-job {
  border-color: var(--map-job);
  border-top-style: dashed;
}
.zy-capability-map__legend .zy-capability-map__key-gap {
  border-color: var(--map-gap);
}
@media print {
  .zy-capability-map {
    --map-candidate: var(--zy-report-candidate) !important;
    --map-job: var(--zy-report-role) !important;
    --map-gap: var(--zy-report-follow-up) !important;
    --map-strength: var(--zy-report-strength) !important;
    color: var(--zy-text-strong) !important;
    break-inside: avoid;
  }
}

.zy-capability-map__legend .zy-capability-map__key-strength {
  border-color: var(--map-strength);
  border-top-style: dotted;
  border-top-width: 5px;
}
.zy-capability-map__help {
  text-align: left;
  font-size: 0.85rem;
  margin-top: 1rem;
}
.zy-capability-map__help li {
  margin-block: 0.5rem;
}
.zy-capability-map__help > summary {
  min-height: 44px;
  cursor: pointer;
}
.zy-capability-map__values-list {
  display: grid;
  gap: 0.9rem;
  margin: 0 0 1rem;
  overflow-wrap: anywhere;
}
.zy-capability-map__values-list dt {
  font-weight: 700;
}
.zy-capability-map__values-list dd {
  display: grid;
  gap: 0.2rem;
  margin: 0.25rem 0 0;
}
